import './App.css';
import { Context, createContext, useEffect, useRef, useState } from 'react';
import { CategoryInfo, emptyState, useCategories } from './util/use-categories';
import { counterSubscribe, counterUnsubscribe } from './util/api';
import { debounce } from './util/misc';
import TemplateComponent from './components/templates';

export const CategoriesContext: Context<CategoryInfo> = createContext(emptyState as CategoryInfo);

function App() {
    const [hasPendingRequests, setHasPendingRequests] = useState(true);
    const pendingRef = useRef(hasPendingRequests);
    pendingRef.current = hasPendingRequests;
    useEffect(() => {
        // если ничего не грузилось и начало, то ставим прелоадер сразу
        // в остальных случаях с небольшим дебаунсом
        // чтобы не мигал при поочередных запросах
        const debounced = debounce((k: number) => {
            setHasPendingRequests(k > 0);
        }, 100);
        const sub = (k: number) => {
            if (k > 0 && !pendingRef.current) {
                setHasPendingRequests(true);
            } else {
                debounced(k);
            }
        };
        counterSubscribe(sub);
        return () => counterUnsubscribe(sub);
    }, []);
    const categories = useCategories();

    return (
        <CategoriesContext.Provider value={categories}>
            <TemplateComponent hasPendingRequests={hasPendingRequests} />
        </CategoriesContext.Provider>
    );
}

export default App;
